import { Injectable } from "@angular/core";
import { datadogRum } from "@datadog/browser-rum";
import { environment } from "@env/environment";
import { UserService } from "./user.service";

@Injectable({
  providedIn: "root",
})
export class DatadogService {
  constructor(private userService: UserService) {}

  public init() {
    try {
      if (environment.dd_applicationId && environment.dd_clientToken) {
        datadogRum.init({
          applicationId: environment.dd_applicationId,
          clientToken: environment.dd_clientToken,
          site: "datadoghq.com",
          service: "scaffold-" + environment.env,
          env: environment.env,
          // Specify a version number to identify the deployed version of your application in Datadog
          // version: '1.0.0',
          sessionSampleRate: 100,
          sessionReplaySampleRate: 100,
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          defaultPrivacyLevel: "mask-user-input",
        });
        datadogRum.startSessionReplayRecording();
        this.userService.getRoleDetails().subscribe((user: any) => {
          const dd_user = datadogRum.getUser();
          const setUser = {
            id: user.user_id,
            name: user.cognito_username,
            email: user.data.email,
            role: user.role,
            instance: environment.domain,
            institution_id: user.institution_id
          };
          if (dd_user?.id !== setUser.id) {
            datadogRum.clearUser();
            datadogRum.setUser(setUser);
          }
        });
      }
    } catch (error) {}
  }
}
